module.exports = __webpack_public_path__ + "static/media/flx.7faa5aa7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/flx.png
// module id = 725
// module chunks = 0